<div class="nova__dialog__toolbar" cdkDrag>
    <div class="nova__dialog__toolbar__title">
        {{ title }}
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    <div class="message">
        <p>
            Please choose a reason for declining this offer. <br />
            Fields marked with an [*] are required
        </p>
    </div>
    <div class="form-container">
        <form [formGroup]="offerDeclineFormGroup" (ngSubmit)="onSubmit()" class="form-container">

            <div class="form-row">
                <div class="form-field form-field--left">
                    <span class="label-text label-text--center">Reason*</span>
                </div>
                <div class="form-field form-field--right">
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="reasonId" data-qa-id="ReasonInput">
                            <mat-option *ngFor="let option of declineReasons" [value]="option" (onSelectionChange)="reasonSelection($event)">{{ option.name }}</mat-option>
                        </mat-select>

                        <mat-error>Please select a Reason</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-row">
                <div class="form-field form-field--left">
                </div>
                <div class="form-field form-field--right">
                    <div class="form-col">
                        <div *ngIf="
                            offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningDifferentFacility ||
                            offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningThisFacility">
                            <div class="form-row">
                                <div class="form-field form-field--left">
                                    <span class="label-text label-text--center">Agency*</span>
                                </div>
                                <div class="form-field form-field--right">
                                    <mat-form-field appearance="outline">
                                        <input type="text" placeholder="Choose Agency*" matInput formControlName="vendorId"
                                            [matAutocomplete]="auto" data-qa-id="AgencyIdInput">
                                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="checkValue">
                                            <mat-option *ngFor="let option of incomingDeclineData.vendorOptions" [value]="option">
                                                {{option.legalName}}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-progress-spinner *ngIf="isAgencyLoading" matSuffix mode="indeterminate" strokeWidth="2"
                                            diameter="24">
                                        </mat-progress-spinner>
                                        <mat-error>Please choose an option</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-row" *ngIf="offerDeclineFormGroup.get('vendorId')?.value?.id === vendorEnum.Other">
                                <div class="form-field form-field--left"></div>
                                <div class="form-field form-field--right">
                                    <mat-form-field appearance="outline">
                                        <input matInput type="text" placeholder="Type an Agency" formControlName="vendorName"
                                            data-qa-id="AgencyNameInput">
                                        <mat-error>Please type an agency</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="form-col" *ngIf="
                        offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningAya ||
                        offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningDifferentFacility ||
                        offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningThisFacility">
                            <div class="form-field form-field--left">
                                <span *ngIf="offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningAya" class="label-text">Why did the candidate select this facility?*</span>
                                <span *ngIf="offerDeclineFormGroup.get('reasonId')?.value?.id !== reasonEnum.SigningAya" class="label-text">Why did the candidate select this agency?*</span>
                            </div>
                            <div class="form-field form-field--right">
                                <mat-form-field appearance="outline">
                                    <mat-select multiple formControlName="subReasonIds" placeholder="Select one or more reasons*" data-qa-id="SubReasonIdsInput">
                                        <mat-option #subReasonOption
                                                    *ngFor="let option of subReasonsList"
                                                    [value]="getVendorId(option)"
                                                    [disabled]="checkSubReasonDisabled(subReasonOption)"
                                                    (onSelectionChange)="subReasonSelect($event, subReasonOption)">
                                            {{ option.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>Please make at least 1 selection</mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline" *ngIf="showOtherTextField">
                                    <input type="text" placeholder="Enter Other Reason" matInput formControlName="otherReasonText" data-qa-id="OtherReasonInput">
                                </mat-form-field>

                                <mat-chip-list aria-label="Decline Sub Reasons" class="sub-chips">
                                    <mat-chip disableRipple *ngFor="let sub of offerDeclineFormGroup.get('subReasonIds').value">
                                        {{ getChipName(sub) }}
                                    </mat-chip>
                                </mat-chip-list>
                            </div>
                        </div>

                        <div class="form-row form-row-pay form-row--align-center" *ngIf="showPayFields">
                            <div class="form-field form-field--left">
                                <span class="label-text">Enter Pay*</span>
                            </div>
                            <div class="form-field form-field--right">
                                <mat-form-field appearance="legacy">
                                    <mat-radio-group aria-label="Enter Pay" class="pay-radio-group" formControlName="pay" data-qa-id="PayInput">
                                        <mat-radio-button value="1"></mat-radio-button>
                                        <mat-form-field appearance="outline" floatLabel="never" class="pay-form-field">
                                            <input matInput type="text" formControlName="payRate" data-qa-id="PayRateInput">
                                            <mat-select formControlName="payFreq" data-qa-id="PayFreqInput">
                                                <mat-option value="week">/wk</mat-option>
                                                <mat-option value="hour">/hr</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-radio-button value="0">
                                            <span class="bold">Unknown</span>
                                        </mat-radio-button>
                                    </mat-radio-group>

                                   <mat-error *ngIf="offerDeclineFormGroup.get('payRate').invalid">
                                        Please enter a valid Pay Rate
                                    </mat-error>
                                    <mat-error *ngIf="offerDeclineFormGroup.get('pay').invalid">
                                        Please select an option
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="form-row form-row-candidate" *ngIf="
                        offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningDifferentFacility ||
                        offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningThisFacility">
                            <div class="form-field form-field--left">
                                <span class="label-text">Candidate was</span>
                            </div>
                            <div class="form-field form-field--right">
                                <mat-radio-group aria-label="Candidat was" formControlName="isExistingVendorForCandidate" class="candidate-radio-group" data-qa-id="ExistingVendorCanInput">
                                    <mat-radio-button value="true"><span class="bold">Existing</span> to this agency</mat-radio-button>
                                    <mat-radio-button value="false"><span class="bold">New</span> to this agency</mat-radio-button>
                                </mat-radio-group>
                                <mat-error *ngIf="offerDeclineFormGroup.get('isExistingVendorForCandidate').invalid &&
                                                                        offerDeclineFormGroup.get('isExistingVendorForCandidate').touched"
                                    class="error-msg">
                                    Please select an option
                                </mat-error>
                            </div>
                        </div>
                        <div *ngIf="
                            offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningAya ||
                            offerDeclineFormGroup.get('reasonId')?.value?.id === reasonEnum.SigningDifferentFacility">
                            <div class="form-row">
                                <div class="form-field form-field--left">
                                    <span class="label-text label-text--center">Facility*</span>
                                </div>
                                <div class="form-field form-field--right">
                                    <mat-form-field appearance="outline">
                                        <input type="text" placeholder="Choose Facility*" matInput formControlName="facilityId"
                                            [matAutocomplete]="auto" data-qa-id="FacilityIdInput">
                                        <mat-icon matSuffix *ngIf="!isFacilityLoading">search</mat-icon>
                                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="checkFacilityValue">
                                            <mat-option *ngFor="let option of incomingDeclineData.facilityOptions" [value]="option">
                                                {{ option.name}}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-progress-spinner *ngIf="isFacilityLoading" matSuffix mode="indeterminate" strokeWidth="2"
                                            diameter="24">
                                        </mat-progress-spinner>
                                        <mat-error>Please choose an option</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-row" *ngIf="offerDeclineFormGroup.get('facilityId')?.value?.id === vendorEnum.Other">
                                <div class="form-field form-field--left"></div>
                                <div class="form-field form-field--right">
                                    <mat-form-field appearance="outline">
                                        <input matInput type="text" placeholder="Type a Facility" formControlName="facilityName"
                                            data-qa-id="FacilityNameInput">
                                        <mat-error>Please type a facility</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <br />
            <div *ngIf="!isCommentsFieldRequired; else elseBlock" class="form-row">
                <div class="form-field form-field--left">
                    <span class="label-text label-text--center">Comment <br />(Optional)</span>
                </div>
                <div class="form-field form-field--right">
                    <mat-form-field appearance="outline">
                        <textarea matInput rows="6" formControlName="reasonText" class="comments-textarea"
                            data-qa-id="ReasonTextInput"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <ng-template #elseBlock>
                <div class="form-row">
                    <div class="form-field form-field--left">
                        <span class="label-text label-text--center">Comment* <br />(Required)</span>
                    </div>
                    <div class="form-field form-field--right">
                        <mat-form-field appearance="outline">
                            <textarea matInput required="true" rows="6" formControlName="reasonText" class="comments-textarea"
                                data-qa-id="ReasonTextInput"></textarea>
                            <mat-error>Please leave a comment</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </ng-template>
        </form>
    </div>

    <mat-dialog-actions class="nova__dialog__content__actions">
        <button type="submit"
                (click)="onSubmit()"
                mat-raised-button
                color="primary">
            DECLINE OFFER
        </button>
        <button mat-raised-button
                color="default"
                (click)="close()">
            CANCEL
        </button>
    </mat-dialog-actions>
</div>
